/**
 * Hook do śledzenia głębokości przewijania strony
 * Automatycznie wysyła zdarzenia analytics na 25%, 50%, 75%, 100%
 */

import { useEffect, useRef } from 'react';
import { trackScrollDepth } from '@/utils/analyticsTracking';

const SCROLL_THRESHOLDS = [25, 50, 75, 100];

export function useScrollDepthTracking() {
  const trackedThresholds = useRef(new Set());

  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = window.scrollY;
      const scrollPercentage = scrollHeight > 0 ? Math.round((scrolled / scrollHeight) * 100) : 0;

      SCROLL_THRESHOLDS.forEach(threshold => {
        if (scrollPercentage >= threshold && !trackedThresholds.current.has(threshold)) {
          trackedThresholds.current.add(threshold);
          trackScrollDepth(threshold);
        }
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
}

export default useScrollDepthTracking;